import React, { useState, useEffect } from "react";
import _ from "lodash";
import {
  Box,
  Typography,
  CircularProgress,
  Grid,
  Paper,
} from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";

import moment from "moment";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
import * as Icons from "@material-ui/icons";
import { PageTitle } from "../partials/pageTitle";

import { GET_INDUSTRY } from "../_redux/dashboardCrud";

import { CustomSlider } from "../partials/slider";
import { PreparationFilter } from "../partials/preparationFilter";
// Sub Components

import store from "../../../../redux/store";
import { useParams } from "react-router";

export function IndustryDetails() {
  const { id: industryId } = useParams();

  useQuery(GET_INDUSTRY, {
    fetchPolicy: "cache-first",
    variables: {
      getIndustryBlsIndustryId: industryId,
    },
    onCompleted: (data) => {
      setQueryResult(data);
      setOccupations(
        data.getIndustry.occupations
          .filter((oc) => {
            if (
              _.find(data.getIndustry.occupationAnnualWageMap, {
                blsOccupationId: oc.blsOccupationId,
              })
            )
              return true;
            else return false;
          })
          .map((occupation) => {
            if (
              !_.find(data.getIndustry.occupationAnnualWageMap, {
                blsOccupationId: occupation.blsOccupationId,
              })
            ) {
              console.log(
                "**********************************************************"
              );
              console.log(occupation);
            }
            return {
              ...occupation,
              id: occupation.occupationId,
              annualMedianWage: _.find(
                data.getIndustry.occupationAnnualWageMap,
                {
                  blsOccupationId: occupation.blsOccupationId,
                }
              ).value,
            };
          })
      );
    },
  });

  // useEffect(() => {
  //   getIndustry();
  // }, [getIndustry]);

  const [queryResult, setQueryResult] = useState(undefined);
  const [occupations, setOccupations] = useState([]);

  const {
    auth: { tokenExpiresAt },
  } = store.getState();
  if (moment().isAfter(moment(tokenExpiresAt))) {
    localStorage.clear();
  }

  function getImageSrc(industryId) {
    switch (industryId) {
      case "71--72":
        return "/media/icons/arts.png";

      case "000000":
        return "/media/icons/government.png";

      case "61--62":
        return "/media/icons/education.png";

      case "62--63":
        return "/media/icons/health.png";

      case "48--50":
        return "/media/icons/transportation.png";

      case "52--53":
        return "/media/icons/finance.png";

      case "55--56":
        return "/media/icons/management.png";

      case "72--73":
        return "/media/icons/accomodation.png";

      case "23--24":
        return "/media/icons/construction.png";

      case "11--12":
        return "/media/icons/farming.png";

      case "31--34":
        return "/media/icons/manufacturing.png";

      case "81--82":
        return "/media/icons/service.png";

      case "22--23":
        return "/media/icons/utilities.png";

      case "21--22":
        return "/media/icons/mining.png";

      case "42--43":
        return "/media/icons/wholesale.png";

      case "44--46":
        return "/media/icons/retail.png";

      case "54--55":
        return "/media/icons/science.png";

      case "53--54":
        return "/media/icons/realEstate.png";

      case "56--57":
        return "/media/icons/support.png";

      case "51--52":
        return "/media/icons/information.png";

      default:
        return "";
    }
  }
  const [minimumWageValue, setMinimumWageValue] = useState(0);

  const handleSliderChange = (event, newValue) => {
    setMinimumWageValue(newValue);
    let occupationIds = [];
    let filteredOccupations = queryResult.getIndustry.occupations;
    if (preparationLevel.length) {
      filteredOccupations = filteredOccupations.filter((occupation) =>
        preparationLevel.includes(occupation.jobZoneId)
      );
    }
    queryResult.getIndustry.occupationAnnualWageMap.forEach((occupation) => {
      if (occupation.value >= newValue) {
        occupationIds.push(occupation.blsOccupationId);
      }
    });
    filteredOccupations = filteredOccupations.filter((occupation) =>
      occupationIds.includes(occupation.blsOccupationId)
    );
    filteredOccupations = filteredOccupations
      .filter((oc) => {
        if (
          _.find(queryResult.getIndustry.occupationAnnualWageMap, {
            blsOccupationId: oc.blsOccupationId,
          })
        )
          return true;
        else return false;
      })
      .map((occupation) => {
        return {
          ...occupation,
          id: occupation.occupationId,
          annualMedianWage: _.find(
            queryResult.getIndustry.occupationAnnualWageMap,
            {
              blsOccupationId: occupation.blsOccupationId,
            }
          ).value,
        };
      });
    setOccupations(filteredOccupations);
  };

  function getPreparationImageSrc(level) {
    switch (level) {
      case 1:
        return "/media/svg/preparation-needed/1.svg";
      case 2:
        return "/media/svg/preparation-needed/2.svg";
      case 3:
        return "/media/svg/preparation-needed/3.svg";
      case 4:
        return "/media/svg/preparation-needed/4.svg";
      case 5:
        return "/media/svg/preparation-needed/5.svg";

      default:
        return "";
    }
  }

  const [preparationLevel, setPreparationLevel] = useState([]);

  function changePreparationLevel(level) {
    let levels = [];
    levels = preparationLevel;
    if (preparationLevel.includes(level)) {
      levels.splice(levels.indexOf(level), 1);
    } else {
      levels.push(level);
    }
    let filteredOccupations = queryResult.getIndustry.occupations;

    if (levels.length) {
      filteredOccupations = queryResult.getIndustry.occupations.filter(
        (occupation) => levels.includes(occupation.jobZoneId)
      );
    }
    if (minimumWageValue !== 0) {
      let occupationIds = [];
      queryResult.getIndustry.occupationAnnualWageMap.forEach((occupation) => {
        if (occupation.value >= minimumWageValue) {
          occupationIds.push(occupation.blsOccupationId);
        }
      });
      filteredOccupations = filteredOccupations.filter((occupation) =>
        occupationIds.includes(occupation.blsOccupationId)
      );
    }
    filteredOccupations = filteredOccupations
      .filter((oc) => {
        if (
          _.find(queryResult.getIndustry.occupationAnnualWageMap, {
            blsOccupationId: oc.blsOccupationId,
          })
        )
          return true;
        else return false;
      })
      .map((occupation) => {
        return {
          ...occupation,
          id: occupation.occupationId,
          annualMedianWage: _.find(
            queryResult.getIndustry.occupationAnnualWageMap,
            {
              blsOccupationId: occupation.blsOccupationId,
            }
          ).value,
        };
      });
    setOccupations(filteredOccupations);
    setPreparationLevel(levels);
  }

  const columns = [
    {
      field: "title",
      headerName: "Occupation",
      width: 600,
      renderCell: (params) => {
        return (
          <Box
            // onClick={() => {
            //   history.push(
            //     `/occupation/${industryId}/${params.row.occupationId}`
            //   );
            // }}
            style={{ cursor: "pointer" }}
          >
            <Link to={`/occupation/${industryId}/${params.row.occupationId}`}>
              <Typography color="secondary"> {params.value}</Typography>
            </Link>
          </Box>
        );
      },
    },
    {
      field: "jobZoneId",
      headerName: "Preparation",
      width: 250,
      renderCell: (params) => {
        if (!params.value) {
          return "N/A";
        }
        return (
          <img
            width={30}
            height={25}
            src={getPreparationImageSrc(params.value)}
            alt={params.value}
          />
        );
      },
    },
    {
      field: "annualMedianWage",
      headerName: "Annual Median Wage",
      width: 250,
      renderCell: (params) => {
        if (!params.value) {
          return "N/A";
        }
        return "$" + params.value;
      },
    },
  ];

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      style={{ backgroundColor: "white" }}
      px={2}
    >
      <PageTitle></PageTitle>
      {!queryResult ? (
        <Box mt={3} p={5}>
          <CircularProgress style={{ color: "#3699FF" }} />
        </Box>
      ) : (
        <Box mt={2} display="flex" flexDirection="column" alignItems="center">
          <Box width="100%">
            <Paper>
              <Box p={2}>
                <Grid container spacing={1}>
                  <Grid item xs={4} md={2} lg={1}>
                    <Box>
                      <img src={getImageSrc(industryId)} alt={"TEST"} />
                    </Box>
                  </Grid>
                  <Grid item xs={8} md={10}>
                    <Box mb={2}>
                      <Typography variant="h4">
                        {queryResult.getIndustry.industry.title}
                      </Typography>
                      employs {queryResult.getIndustry.employment}
                    </Box>
                  </Grid>
                  <Grid item container alignItems="center">
                    <Grid item xs={12} md={3}>
                      <Box display="flex" mr={5} mb={2}>
                        <Box mr={3}>Total Projected Openings</Box>{" "}
                        <Typography variant="h6">
                          {" "}
                          {Math.round(
                            queryResult.getIndustry.industry.projectedOpenings
                          )}{" "}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Box display="flex" mr={5} mb={2}>
                        <Box mr={3}>Annual Median Wage</Box>{" "}
                        <Typography variant="h6">
                          {" "}
                          ${queryResult.getIndustry.annualMedianWage}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Box display="flex" mb={2}>
                        <Box mr={3}>Hourly Median Wage</Box>{" "}
                        <Typography variant="h6">
                          {" "}
                          ${queryResult.getIndustry.hourlyMedianWage}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Paper>
          </Box>{" "}
          <Grid container>
            <Grid item xs={12} md={12}>
              <Box my={2}>
                <Paper>
                  <Box p={4}>
                    <Typography variant="h5">About this Industry</Typography>
                    <Box
                      flexGrow={1}
                      height={3}
                      width="10%"
                      style={{ backgroundColor: "#01a9f4" }}
                      my={1}
                    ></Box>
                    <Typography>
                      {queryResult.getIndustry.industry.description}
                    </Typography>
                  </Box>
                </Paper>
              </Box>
            </Grid>
          </Grid>
          <Box textAlign="center" my={3}>
            <Typography variant="h2">OCCUPATION FILTERS</Typography>
          </Box>
          <PreparationFilter
            changePreparationLevel={changePreparationLevel}
            preparationLevel={preparationLevel}
          />
          <Box display="flex" width="60%" mt={3} mb={3}>
            <Icons.MonetizationOn
              fontSize="large"
              style={{ color: "#01a9f4" }}
            />
            <CustomSlider
              valueLabelDisplay="on"
              aria-label="pretto slider"
              onChange={handleSliderChange}
              step={5000}
              min={_.min(
                queryResult.getIndustry.occupationAnnualWageMap.map(
                  (bls) => bls.value
                )
              )}
              max={_.max(
                queryResult.getIndustry.occupationAnnualWageMap.map(
                  (bls) => bls.value
                )
              )}
            />
          </Box>
          <Box height={650} width={1}>
            <DataGrid
              // hideFooter
              // hideFooterPagination
              pageSize={10}
              rows={occupations}
              columns={columns}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
}
